module.exports = __webpack_public_path__ + "static/img/products application_rooftop1.e3338406.jpg";